import { Box, Icon, IconOptions, Spacer, Text } from '@jfs/ui-new'
import { useEffect } from 'react'
import { FORM_MESSAGE } from '../../utils/constants'
import { styles } from './styles'
export enum TimeOut {
  NEVER = -1,
  NOW = 1,
  ONE_SECOND = 1000,
  THREE_SECONDS = 3000,
  FIVE_SECONDS = 5000,
  SIX_SECONDS = 6000,
  TEN_SECONDS = 10000,
  FIFTEEN_SECONDS = 15000,
  THIRTY_SECONDS = 30000,
}
export enum ToastPosition {
  TOP = 'TOP',
  BOTTOM = 'BOTTOM',
  CENTER = 'CENTER',
}

export enum ToastType {
  POSITIVE = 'POSITIVE',
  NEGATIVE = 'NEGATIVE',
  NEUTRAL = 'NEUTRAL',
}

type ToastProps = {
  testID?: string
  hide: boolean
  type: keyof typeof ToastType
  position?: keyof typeof ToastPosition
  message?: string
  onDismiss?: () => void
  timeOut?: TimeOut
  code?: string
}

export const Toast = ({
  type = ToastType.NEGATIVE,
  hide = false,
  message = '',
  position = ToastPosition.TOP,
  onDismiss,
  timeOut = TimeOut.FIVE_SECONDS,
  code = '',
}: ToastProps) => {
  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout> | any
    if (!hide) {
      timeout = setTimeout(onDismiss, timeOut)
    }
    return () => clearTimeout(timeout)
  }, [hide, onDismiss, timeOut])

  if (hide || message === '' || code === FORM_MESSAGE) {
    return null
  }
  const getIcon = () => {
    const Icons = {
      POSITIVE: 'ROUND_TICK',
      NEUTRAL: 'INFO',
      NEGATIVE: 'CLEAR',
    }
    return Icons[type] as IconOptions
  }

  // testID={testID} removed this while migration
  const boxStyle = { ...styles[position].containerView, ...styles[type].bgColor }
  return (
    <Box onPress={onDismiss} {...boxStyle}>
      <Box maxWidth={'92%'} flexDirection={'row'}>
        <Text {...styles[type].titleText} numberOfLines={2} textAlign={'left'} testID={'toast-text'}>
          {message}
        </Text>
        <Spacer size={8} direction={'horizontal'} />
      </Box>
      <Icon id={getIcon()} color="WHITE" size="FONT_SIZE_2_EXTRA_LARGE" />
    </Box>
  )
}
